import React, { useEffect, useState } from 'react'
import Lottie from "lottie-react";
import SuccessLotie from "./../Assets/lottieFiles/success.json";
import LoadingLottie from "./../Assets/lottieFiles/PinglebookingLoader.json";
import FailedLottie from "./../Assets/lottieFiles/PaymentFailed.json";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getDatabase, ref, onValue, Database } from "firebase/database";

const PaymentCompleted = () => {
    const [paymentLoading, setPaymentLoading] = useState(true);
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [paymentFailed, setPaymentFailed] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const [error, setError] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();
    // Parse query params
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get("order_id");
    const type = queryParams.get("type");
    const userID = queryParams.get("user_id");


    useEffect(() => {
        // cartid
        let check = localStorage.getItem("cartid");
        if (check == "") {
            navigate('/')
        }
        let checkScreen = localStorage.getItem('bookingConfirm')
        if (checkScreen == 'true') {
            navigate('/')
        }
    }, [])


    // useEffect(() => {
    //     const database = getDatabase();
    //     let orderRef = ref(database, `/payments/product_order/${userID}`);
    //     if (type == "productOrder") {
    //         orderRef = ref(database, `/payments/product_order/${userID}`);
    //     } else if (type == "serviceBooking") { 
    //         orderRef = ref(database, `/payments/service_booking/${userID}`);
    //     }

    //     console.log("/payments/product_order", { userID, type, orderId });

    //     const unsubscribe = onValue(orderRef, (snapshot) => {
    //         const data = snapshot.val();
    //         console.log("/payments/product_order", data);
    //         setPaymentData(data);
    //         if (data?.status == 2 && data?.order_id == orderId) {
    //             setPaymentLoading(false)
    //             setPaymentSuccess(true)
    //         } else if (data?.status == 3 && data?.order_id == orderId) {
    //             setPaymentLoading(false)
    //             setPaymentFailed(true)
    //         }



    //     });
    //     return () => unsubscribe();

    // }, [orderId]); 
    useEffect(() => {
        if (!userID || !orderId || !type) return;

        const database = getDatabase();
        let orderRefPath = "";

        if (type == "productOrder") {
            orderRefPath = `/payments/product_order/${userID}`;
        } else if (type == "serviceBooking") {
            orderRefPath = `/payments/service_booking/${userID}`;
        } else if (type == "kitchenMembership") {
            orderRefPath = `/payments/kitchen_membership_ticket/${userID}`;
        } else if (type == "kitchenTicket") {
            orderRefPath = `/payments/kitchen_ticket/${userID}`;
        }
        else if (type == "pingtopup") {
            orderRefPath = `/payments/topup_pings/${userID}`;
        }
        console.log('orderRefPath---', orderRefPath);

        const orderRef = ref(database, orderRefPath);

        const unsubscribe = onValue(orderRef, (snapshot) => {
            const data = snapshot.val();
            console.log(' snapshot.val()---', data);

            if (data?.order_id == orderId) {
                setPaymentData(data);

                if (data?.status == 2) {
                    setPaymentLoading(false);
                    setPaymentSuccess(true);
                } else if (data?.status == 3) {
                    setPaymentLoading(false);
                    setPaymentFailed(true);
                }
            }
        });

        return () => unsubscribe();
    }, [userID, orderId, type]);



    console.log('paymentData--------', paymentData);
    console.log('type--------', type);

    const handleSuccess = async () => {

        if (type == "productOrder") {
            navigate(`/ProductPass/${paymentData?.product_order_id}`, { replace: true, state: { orderid: paymentData?.product_order_id, fromPage: "ReviewPay" } });
            localStorage.setItem('bookingConfirm', 'true')
            localStorage.removeItem("recordedAudioUrl");
            localStorage.removeItem("seletedPayType");
            [
                "EditOrder_Detail", "localStorageserviceTime",
                "shipping_type", "cartid", "appliedCard", "recordedURL",
                "cart_items", "productCart", "additionalNotes", "audioDuration",
                "deliveryInstructions", "recordedAudio"
            ].forEach((key) => localStorage.removeItem(key));
        }
        else if (type == "serviceBooking") {
            localStorage.removeItem("serviceDetail");
            localStorage.removeItem("selectedServiceOption");
            localStorage.removeItem("appliedCard");
            localStorage.removeItem("seletedPayType");
            localStorage.setItem('bookingConfirm', 'true')
            navigate(`/details/${paymentData.booking_id}`, { state: { fromPage: "ReviewPay" } });
        }
        else if (type == "pingtopup") {
            let topupPage = localStorage.getItem('kitchen_Cart')
            if (topupPage) {
                navigate('/Review-Pay')
            } else {
                navigate('/my-wallet');
            }
        }
        else {
            localStorage.removeItem("kitchen_Cart");
            localStorage.removeItem("appliedCard");
            navigate(`/order-pass/${paymentData?.ticket_order_id}`, { replace: true, state: { fromPage: "ReviewPay" } });
        }
    }


    useEffect(() => {
        const handleBackButton = () => {
            // Prevent navigation
            window.history.pushState(null, "", window.location.href);
        };

        // Add a fake state to prevent actual back
        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, []);




    return (
        <div
            style={{
                backgroundColor: "#fff",
                height: "100vh",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {paymentLoading ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}>

                    <Lottie animationData={LoadingLottie} loop={true} autoPlay={true} />
                    <div className="mt-2 text-center fw-bold primary-text">
                        Please wait, verifying payment
                    </div>
                </div>
            ) : (
                <>
                    {
                        paymentSuccess && (
                            <div style={{ backgroundColor: "#fff", height: "100vh", width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", }} >
                                <Lottie animationData={SuccessLotie} loop={1} autoPlay={true} />
                                <div className="mt-1 text-center fw-bold primary-text">Payment Success.</div>
                                <div className="text-center mb-3">
                                    {type != 'pingtopup' && <div className="fw-bold">Redirecting you to your ticket.</div>}
                                    <button
                                        type="button"
                                        className="lottieOkBtn rounded-pill mt-2"
                                        onClick={() => handleSuccess()}
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>
                        )}

                    {paymentFailed && (
                        <div
                            style={{
                                backgroundColor: "#fff",
                                height: "100vh",
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Lottie animationData={FailedLottie} loop={1} autoPlay={true} />
                            <div className="mt-1 text-center fw-bold primary-text">Payment Failed.</div>
                            <div className="text-center mb-3">
                                <div className="fw-bold">Try Again?</div>
                                <button
                                    type="button"
                                    className="lottieOkBtn rounded-pill mt-2"
                                    onClick={() => navigate(-1)}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>

    )
}

export default PaymentCompleted